import { render, staticRenderFns } from "./DemoReport.vue?vue&type=template&id=00d177f7&scoped=true&"
import script from "./DemoReport.vue?vue&type=script&lang=js&"
export * from "./DemoReport.vue?vue&type=script&lang=js&"
import style0 from "./DemoReport.vue?vue&type=style&index=0&id=00d177f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d177f7",
  null
  
)

export default component.exports